import { useEffect, useCallback } from "react";
import { Configuration } from "../types/configuration";
import ConfiguratorService from "src/services/configuratorService";
import ConfigurationService from "src/services/configurationService";
import CalculationService from "src/services/calculationService";
// import {
//   addHouseWalls,
//   addSideWalls,
//   removeHouseWalls,
// } from "src/helpers/walls";
// @ts-ignore
import isEqual from "lodash/isEqual";
import {
  isTwoPostsChosen,
  resolveVelvetlineMaterial,
  resolveVelvetlineSpan,
} from "src/data/velvetlinePrices";
// @ts-ignore
// import sortBy from "lodash/sortBy";
// import { calculateKapschuurBigHeight } from "src/helpers/configuration";
// import { stat } from "fs";

// const sortWalls = (wall: Wall) => wall.id;

const useSynchronizeServices = (
  state: Configuration,
  isInitial: boolean,
  configuration: ConfigurationService,
  calculation: CalculationService,
  configurator: ConfiguratorService,
  setWalls: (walls: Configuration["walls"]) => void,
  setIsInitial: (isInitial: boolean) => void,
  setTotalPrice: (totalPrice: string) => void
) => {
  const synchronize = useCallback(() => {
    // Update configurator
    configurator.setState(state);

    // const tmpDepth = state.dimensions.depth;
    let updatedWalls = state.walls;
    const currentWalls = configuration.getWalls();

    // updatedWalls = configurator.updateCommonStoragesWalls(
    //   updatedWalls,
    //   currentWalls
    // );

    // if (state.roofType === 'kapschuur') {
    //     state.dimensions.height = 3000;
    //     state.dimensions.overhangBack = 0;
    //     state.dimensions.overhangFront = 0;
    //     state.dimensions.overhangLeft = 0;
    //     state.dimensions.overhangRight = 0;
    // }

    // if (state.roofType === 'platdak') {
    //     state.dimensions.height = 2200;
    // }

    // if (isInitial || configuration.getRoofType() !== state.roofType) {
    //   state.dimensions.depth = 3000;

    // //   if (state.roofType === "platdak") {
    // //     state.dimensions.overhangFront = 150;
    // //     state.roof.type = "empty";
    // //   }

    // //   if (state.roofType === "kapschuur") {
    // //     state.roof.type = "empty";
    // //   }

    //   if (state.roofType === "aludra") {
    //     state.roof.type = "empty";
    //   }
    // }

    // Dimensions & storages
    const currentDimensions = configuration.getDimensions();

    if (isInitial || !isEqual(currentDimensions, state.dimensions)) {
      configurator.changeSize();
      // configurator.changeStorageWidth();
    }

    // Roof type
    if (isInitial || configuration.getRoofType() !== state.roofType) {
      configurator.changeRoofType();
      // configurator.changeSize();
    }

    // De overspanning hing hiervoor aan de twee blokken hierboven, en bereikte
    // de 3D dus alleen als de afmetingen of het daktype veranderden. Nu hij ook
    // van het dakmateriaal afhangt, wordt hij elke synchronisatie doorgegeven:
    // changeLimits eindigt in een recalculate() die toch al idempotent is, en
    // zo hoeft geen enkele nieuwe invoer zich hier nog aan te melden.
    if (state.roofType === "aludra") {
      configurator.changeLimits({ width: 7000, depth: 7000 });
    } else {
      const { frontlimit } = resolveVelvetlineSpan(
        state.dimensions.width,
        state.dimensions.depth,
        resolveVelvetlineMaterial(state.roofGlassMat?.glass),
        isTwoPostsChosen(state.dimensions.frontlimit)
      );

      configurator.changeLimits({ width: frontlimit, depth: 7000 });
    }

    // Roof
    // const currentRoof = configuration.getRoof();
    // console.log(currentRoof);

    // if (isInitial || !isEqual(currentRoof.type, state.roof.type)) {
    //   configurator.changeRoofMaterial();
    // }

    if (isInitial || !isEqual(state.sunScreen, configuration.getSunScreen())) {
      configurator.changeRoofCustomization();
    }

    if (
      isInitial ||
      !isEqual(state.roofMaterial, configuration.getRoofMaterial())
    ) {
      configurator.changeRoofMaterial();
    }

    if (
      isInitial ||
      !isEqual(state.roofGlassMat, configuration.getRoofGlassMat())
    ) {
      configurator.changeRoofCustomization();
    }

    // if (state.lights.enabled && state.lights.lightsOn) {
    //   configurator.toggleClock("night");
    // } else {
    //   configurator.toggleClock("day");
    // }

    // // Options Material
    // if (
    //   isInitial ||
    //   !isEqual(state.optionsMaterial, configuration.getOptionsMaterial())
    // ) {
    //   const trim = state.optionsMaterial.daktrim_blank ? "metalic_ring" : "";
    //   configurator.changeRoofCustomization([trim]);
    // }

    // Gutter
    // const currentGutter = configuration.getGutter();

    if (isInitial || configuration.getGutter().type !== state.gutter.type) {
      configurator.changeRoofCustomization();
    }

    // if (
    //   configuration.getRoofType() !== "platdak" &&
    //   state.roofType === "platdak"
    // ) {
    //   state.gutter.enabled = false;
    //   configurator.toggleGutter();
    // }

    // if (
    //   state.gutter.enabled &&
    //   (isInitial || currentGutter.type !== state.gutter.type)
    // ) {
    //   configurator.updateGutterMaterial();
    // }

    // // Walls and storages
    // const prevStorages = configuration.getStorages();

    // if (isInitial || prevStorages.left !== state.storages.left) {
    //   configurator.changeStorageWidth();

    //   if (state.storages.left) {
    //     updatedWalls = addHouseWalls(
    //       "left",
    //       configuration,
    //       configurator,
    //       updatedWalls
    //     );
    //     setTimeout(() => {
    //       const leftFrontWall = state.walls.find(
    //         (wall: Wall) => wall.storage === "left_front"
    //       );

    //       if (leftFrontWall) {
    //         configurator.focusOnWall(leftFrontWall);
    //       }
    //     }, 500);
    //   } else {
    //     updatedWalls = removeHouseWalls("left", updatedWalls);
    //     configurator.deselectWalls();
    //   }
    // }

    // if (isInitial || prevStorages.right !== state.storages.right) {
    //   configurator.changeStorageWidth();

    //   if (state.storages.right) {
    //     updatedWalls = addHouseWalls(
    //       "right",
    //       configuration,
    //       configurator,
    //       updatedWalls
    //     );

    //     setTimeout(() => {
    //       const rightFrontWall = state.walls.find(
    //         (wall: Wall) => wall.storage === "right_front"
    //       );

    //       if (rightFrontWall) {
    //         configurator.focusOnWall(rightFrontWall);
    //       }
    //     }, 500);
    //   } else {
    //     updatedWalls = removeHouseWalls("right", updatedWalls);
    //     configurator.deselectWalls();
    //   }
    // }

    // // Update walls if they changed

    // update right wall position
    updatedWalls = configurator.updateRightSideWallPositions(updatedWalls);

    if (isInitial || !isEqual(state.spy, configuration.getSpy())) {
      configurator.changeRoofCustomization();
    }

    if (isInitial || !isEqual(state.lights, configuration.getLights())) {
      configurator.changeRoofCustomization();
      if (state.lights.lightsOn) {
        configurator.toggleClock("night");
      } else {
        configurator.toggleClock("day");
      }
    }

    // if (!state.spy.enabled && state.roofType === "oase") {
    //   updatedWalls = addSideWalls(configurator, configuration, updatedWalls);
    // }

    state.walls = updatedWalls;

    // // update right storage position
    // updatedWalls = configurator.updateRightStoragePositions(updatedWalls);

    // // update walls with door and window
    // updatedWalls = configurator.updateDoorWindowWalls(updatedWalls);

    // // update sliding glass door
    // updatedWalls = configurator.updateSlidingGlassWalls(updatedWalls);

    // if (!isEqual(updatedWalls, state.walls)) {
    //   state.walls = updatedWalls;
    // }

    // state.walls = sortBy(state.walls, sortWalls).reverse();

    if (
      isInitial ||
      !isEqual(currentWalls, state.walls) ||
      !isEqual(currentDimensions, state.dimensions)
    ) {
      configurator.updateWalls();
    }

    // configurator.updateColumnTypes();

    // if (isInitial || configuration.getRoofType() !== state.roofType) {
    //   state.dimensions.depth = tmpDepth;
    //   configurator.changeSize();
    //   configurator.updateWalls();
    // }

    // // Calculate additional information
    // state.params.kapschuurBigHeight = calculateKapschuurBigHeight(state);

    // Update ConfigurationService
    configuration.setState(state);

    // Update CalculationService
    calculation.setState(state);
    calculation.calculateConfiguration();
    setTotalPrice(calculation.getFormatTotalPrice());
    configurator.onUpdate();

    if (isInitial) setIsInitial(false);
  }, [
    calculation,
    configuration,
    configurator,
    isInitial,
    setIsInitial,
    setTotalPrice,
    state,
  ]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.CONF && configurator.getColumnsBalks() > 0) {
        clearInterval(interval);
        synchronize();
      }
    }, 500);
  }, [configurator, state, synchronize]);
};

export default useSynchronizeServices;
